import classNames from 'classnames';
import React, { FC } from 'react';

import css from './Loader.module.scss';

export interface LoaderProps {
  className?: any;
  type?: 'small' | 'large';
}

export const Loader: FC<LoaderProps> = ({ className, type = 'large' }) => (
  <div
    className={classNames(css.ellipsis, className, {
      [css.small]: type === 'small',
    })}
    data-sumo-test='loader'
  >
    <div />
    <div />
    <div />
    <div />
  </div>
);
